<div class="app-main__inner">
  <div class="sba-view">

    <!-- ═══ CATEGORY SEARCH VIEW ═════════════════════════════════════ -->
    <ng-container *ngIf="view === 'search'">

      <p class="sba-hint">Enter a category name to search and browse all books in that category.</p>

      <div class="sba-search-row">
        <div class="sba-input-wrap">
          <i class="pe-7s-search sba-input-icon"></i>
          <input type="text" class="sba-input" [(ngModel)]="searchInput"
                 placeholder="Category name..." (keyup.enter)="searchCategories()"
                 [disabled]="isLoadingCategories" />
        </div>
        <button class="sba-search-btn" (click)="searchCategories()"
                [disabled]="isLoadingCategories || !searchInput.trim()">
          <span *ngIf="isLoadingCategories" class="spinner-border spinner-border-sm"></span>
          <i *ngIf="!isLoadingCategories" class="pe-7s-search"></i>
        </button>
      </div>

      <div class="alert alert-danger py-2 px-3 small mb-3" *ngIf="searchError && hasSearched">
        <i class="pe-7s-attention me-1"></i>{{ searchError }}
      </div>

      <div class="sba-empty" *ngIf="hasSearched && !searchError && categoryResults.length === 0">
        <i class="pe-7s-folder sba-empty-icon"></i>
        <p>No categories found matching <strong>"{{ searchInput }}"</strong>.</p>
      </div>

      <div *ngIf="categoryResults.length > 0">
        <p class="sba-results-meta">{{ categoryResults.length }} category/categories found — click one to view its books</p>
        <div class="sba-author-list">
          <div class="sba-author-card" *ngFor="let c of categoryResults" (click)="selectCategory(c)">
            <div class="sba-author-avatar sbc-cat-avatar">
              <i class="pe-7s-folder"></i>
            </div>
            <div class="sba-author-info">
              <div class="sba-author-name">{{ c.categoryName }}</div>
              <div class="sba-author-sub" *ngIf="c.categoryNameEnglish">{{ c.categoryNameEnglish }}</div>
            </div>
            <i class="pe-7s-angle-right sba-arrow"></i>
          </div>
        </div>
      </div>

    </ng-container>

    <!-- ═══ BOOKS VIEW ════════════════════════════════════════════════ -->
    <ng-container *ngIf="view === 'books'">

      <div class="sba-author-strip">
        <button type="button" class="sba-back-btn" (click)="backToSearch()">
          <i class="pe-7s-angle-left"></i>
        </button>
        <div class="sba-strip-avatar sbc-cat-avatar">
          <i class="pe-7s-folder"></i>
        </div>
        <div class="sba-strip-info">
          <div class="sba-strip-name">{{ selectedCategory?.categoryName }}</div>
          <div class="sba-strip-sub" *ngIf="selectedCategory?.categoryNameEnglish">{{ selectedCategory.categoryNameEnglish }}</div>
        </div>
      </div>

      <div class="text-center py-4" *ngIf="isLoadingBooks">
        <div class="spinner-border text-primary spinner-border-sm"></div>
        <p class="text-muted small mt-2">Loading books…</p>
      </div>

      <div class="alert alert-danger py-2 px-3 small" *ngIf="booksError">
        <i class="pe-7s-attention me-1"></i>{{ booksError }}
      </div>

      <div class="sba-empty" *ngIf="!isLoadingBooks && !booksError && categoryBooks.length === 0">
        <i class="pe-7s-bookmarks sba-empty-icon"></i>
        <p>No books found in this category.</p>
      </div>

      <div *ngIf="!isLoadingBooks && categoryBooks.length > 0">
        <p class="sba-results-meta">{{ categoryBooks.length }} title(s) — click a book to view copies and locations</p>

        <div class="sba-book-card" *ngFor="let book of categoryBooks">
          <div class="sba-book-header">
            <div class="sba-book-icon"><i class="pe-7s-notebook"></i></div>
            <div class="sba-book-info">
              <div class="sba-book-name">{{ book.bookName }}</div>
              <div class="sba-book-meta">
                <span class="sba-code" *ngIf="book.bookId">{{ book.bookId }}</span>
              </div>
            </div>
            <div class="sba-stats">
              <span class="sba-stat sba-stat-c" title="At Center">⌂ {{ book.available }}</span>
              <span class="sba-stat sba-stat-m" title="Issued">⇌ {{ book.issued }}</span>
            </div>
            <button class="sba-view-btn" (click)="viewCopies(book)">
              <i class="pe-7s-map-marker me-1"></i> View Copies
            </button>
          </div>
        </div>
      </div>

    </ng-container>

  </div>
</div>

<!-- ── Copies Modal ──────────────────────────────────────────────────────── -->
<div class="sba-modal-backdrop" *ngIf="showCopiesModal" (click)="closeModal()"></div>
<div class="sba-modal" *ngIf="showCopiesModal" (click)="$event.stopPropagation()">

  <div class="sba-modal-header">
    <div class="sba-modal-title">
      <i class="pe-7s-map-marker me-2 text-primary"></i>Copy Locations
    </div>
    <button type="button" class="sba-modal-close" (click)="closeModal()">
      <i class="pe-7s-close"></i>
    </button>
  </div>

  <div class="sba-modal-book-strip">
    <div class="sba-modal-book-icon"><i class="pe-7s-notebook"></i></div>
    <div class="sba-modal-book-info">
      <div class="sba-modal-book-name">{{ selectedBook?.bookName }}</div>
      <div class="sba-modal-book-meta">
        <span class="sba-code" *ngIf="selectedBook?.bookId">{{ selectedBook.bookId }}</span>
        <span class="sba-modal-author" *ngIf="selectedBook?.authorNames?.length">
          {{ selectedBook.authorNames.join(', ') }}
        </span>
      </div>
    </div>
    <div class="sba-stats">
      <span class="sba-stat sba-stat-c" title="At Center">⌂ {{ selectedBook?.available }}</span>
      <span class="sba-stat sba-stat-m" title="Issued">⇌ {{ selectedBook?.issued }}</span>
      <span class="sba-stat sba-stat-t" title="Total">&#x2022; {{ selectedBook?.totalCopies }}</span>
    </div>
  </div>

  <div class="sba-modal-body">

    <div class="sba-copies-loading" *ngIf="isLoadingCopies">
      <div class="spinner-border spinner-border-sm text-primary"></div>
      <span>Loading copies…</span>
    </div>

    <div class="alert alert-danger py-2 px-3 small m-3" *ngIf="!isLoadingCopies && copiesError">
      <i class="pe-7s-attention me-1"></i>{{ copiesError }}
    </div>

    <div class="sba-no-copies text-muted small"
         *ngIf="!isLoadingCopies && !copiesError && selectedBook?.copies?.length === 0">
      No inventory copies found for this book.
    </div>

    <table class="table table-sm sba-copies-table mb-0"
           *ngIf="!isLoadingCopies && selectedBook?.copies?.length > 0">
      <thead>
        <tr><th>Sr No.</th><th>Status</th><th>Location</th></tr>
      </thead>
      <tbody>
        <tr *ngFor="let copy of selectedBook?.copies" [class]="rowClass(copy.status)">
          <td class="sba-srno">{{ copy.bookSrNo }}</td>
          <td>
            <span class="sba-status-badge" [ngClass]="'sba-badge-' + copy.status">
              {{ statusLabel(copy.status) }}
            </span>
          </td>
          <td class="sba-location">{{ copy.location }}</td>
        </tr>
      </tbody>
    </table>

  </div>

</div>
